const SET_REQUESTS = (state, payload) => {
  if (payload.length > 0) {
    for (let elem of payload) {
      elem.id = parseInt(elem.id)
    }
  }
  state.requests = payload
}

const SET_ACTIVE_REQUEST = (state, { request }) => {
  state.activeRequest = request
}

const SET_ONLINE_AUDIOLOGISTS = (state, payload) => {
  state.onlineAudiologists = payload
  state.activeBreak = payload.selfBreak
}

const HANDLE_MINIMIZED_CALL_COLLAPSED = (state) => {
  state.minimizedCallCollapsed = !state.minimizedCallCollapsed
}

const SET_ACTIVE_BREAK = (state, { _break }) => {
  state.activeBreak = _break
}

const RESET_ACTIVE_BREAK = (state) => {
  state.activeBreak = null
}

const RESET_ACTIVE_REQUEST = (state) => {state.activeRequest = null}

const UPDATE_METRICS = (state, {metrics}) => {
  state.metrics = {...metrics}
}

export default {
  SET_REQUESTS,
  SET_ONLINE_AUDIOLOGISTS,
  HANDLE_MINIMIZED_CALL_COLLAPSED,
  SET_ACTIVE_BREAK,
  RESET_ACTIVE_BREAK,
  SET_ACTIVE_REQUEST,
  RESET_ACTIVE_REQUEST,
  UPDATE_METRICS
}
